/**
 * 查看问题
 */
import { Form, Input, Tabs } from 'antd'

const { TabPane } = Tabs
import _ from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { OperateLog, OrderList, OrderResult } from '../components'
import { CheckThePhoneInp } from '@/pages/homePage/components/addClue'
import { checkVipPicturePre } from '@/pages/homePage/components/taskList/components/workDetail.tsx'
import { getFileUrlPrefix } from '@/services'
import { SBack, SGeneralForms } from 'shj-components'
import { useParams } from 'react-router-dom'
import { ticketsIssueDetail, ticketsIssueViewPhone } from '@/services/customerServices.ts'

export const IssueDetailTab = (props: any) => <ModalIssueDetailDom {...props} />

export default (props: any) => {
  const { issueId, id } = useParams() || {}
  return <ModalIssueDetailDom issueId={issueId} id={id} />
}

function ModalIssueDetailDom(props: any) {
  const { id, issueId, fn, formOnly } = props
  const formRef = useRef<any>()
  const [detailsInfo, setDetailsInfo] = useState<any>({})
  const [baseUrl, setBaseUrl] = useState<any>('')
  const [issueListData, setIssueListData] = useState<any>({})
  const baseInfoConfig = [
    {
      isShowBottomBorder: false,
      formItem: [
        {
          name: 'statusDisplay',
          label: '问题状态',
          spanCol: 6,
        },
        // {
        //     name: 'isRepeatCn',
        //     label: '来源',
        //     spanCol: 6,
        // },
        {
          name: 'classifyDisplay',
          label: '分类',
          spanCol: 6,
        },
        {
          name: 'typeDisplay',
          label: '类型',
          spanCol: 6,
        },
        {
          name: 'customerName',
          label: '客户名称',
          spanCol: 6,
        },
        {
          label: '所属门店',
          name: 'companyName',
          spanCol: 6,
        },
        {
          label: '联系电话',
          name: 'phone',
          spanCol: 6,
          customRender: () => {
            return feedbackPhoneRender()
          },
        },
        {
          label: '签约电话',
          name: 'phone',
          spanCol: 6,
          customRender: () => {
            return signPhoneRender()
          },
        },
        {
          name: 'stateDisplay',
          label: '客户状态',
          spanCol: 6,
        },
        {
          name: 'buildingName',
          label: '楼盘名称',
          spanCol: 6,
        },
        {
          name: 'houseNumber',
          label: '房号',
          spanCol: 12,
        },
        {
          name: 'projectCode',
          label: '项目编号',
          spanCol: 6,
        },
        {
          name: 'typeDisplay',
          label: '需求类型',
          spanCol: 6,
        },
        {
          name: 'designDeptDisplay',
          label: '设计部门',
          spanCol: 6,
        },
        {
          name: 'designerDisplay',
          label: '设计师',
          spanCol: 6,
        },
        {
          name: 'designerManager',
          label: '设计部经理',
          spanCol: 6,
        },
        {
          name: 'deliveryDept',
          label: '交付部门',
          spanCol: 6,
        },
        {
          name: 'projectManager',
          label: '项目经理',
          spanCol: 6,
        },
        {
          name: 'engineeringSupervision',
          label: '质检员',
          spanCol: 6,
        },
        {
          name: 'softSteward',
          label: '软装管家',
          spanCol: 6,
        },
        {
          name: 'deliveryManager',
          label: '交付经理',
          spanCol: 6,
        },
        {
          name: 'handoverDate',
          type: 'date',
          label: '交付日期',
          spanCol: 6,
        },
        {
          name: 'planStartDate',
          type: 'date',
          label: '计划开工日期',
          spanCol: 6,
        },
        {
          name: 'planEndDate',
          type: 'date',
          label: '计划完工日期',
          spanCol: 6,
        },
        {
          name: 'actualStartDate',
          type: 'date',
          label: '实际开工日期',
          spanCol: 6,
        },
        {
          name: 'actualEndDate',
          type: 'date',
          label: '实际竣工日期',
          spanCol: 6,
        },
        {
          name: 'disclosureDate',
          type: 'date',
          label: '交底日期',
          spanCol: 6,
        },
        {
          name: 'remoteSite',
          label: '是否远程工地',
          spanCol: 6,
        },
        {
          name: 'visual',
          label: '是否可视化工地',
          spanCol: 6,
        },
        {
          name: 'levelDisplay',
          label: '工单级别',
          spanCol: 6,
        },
        {
          name: 'createdTime',
          label: '创建时间',
          type: 'date',
          spanCol: 6,
        },
        {
          name: 'description',
          label: '问题描述',
          spanCol: 24,
        },
        {
          name: 'file',
          label: '问题附件',
          spanCol: 24,
          customRender: () => {
            return filesRender()
          },
        },
      ],
    },
  ]
  const feedbackPhoneRender = () => {
    return (
      <div style={{ display: 'flex' }}>
        联系电话：
        <div style={{ display: 'flex' }}>
          {detailsInfo.feedbackPhone_}
          <CheckThePhoneInp
            defaultValue
            id={id}
            sysItem={'WORKER_ORDER'}
            param1={'联系电话'}
            fn={(val: any) => {
              setDetailsInfo({
                ...detailsInfo,
                feedbackPhone_: val ? val : detailsInfo?.feedbackPhone,
              })
            }}
            encodeValue={encodeURIComponent(detailsInfo?.feedbackPhoneEncode)}
          />
        </div>
      </div>
    )
  }
  const signPhoneRender = () => {
    return (
      <div style={{ display: 'flex' }}>
        签约电话：
        <div style={{ display: 'flex' }}>
          {detailsInfo.phone_}
          <CheckThePhoneInp
            defaultValue
            id={id}
            sysItem={'WORKER_ORDER'}
            param1={'签约电话'}
            fn={(val: any) => {
              setDetailsInfo({
                ...detailsInfo,
                phone_: val ? val : detailsInfo?.customerInfo?.phone,
              })
            }}
            encodeValue={encodeURIComponent(detailsInfo?.customerInfo?.phoneEncode)}
          />
        </div>
      </div>
    )
  }
  const filesRender = () => {
    return (
      <Form.Item label="问题附件" name="drawDesc">
        {issueListData?.files &&
          JSON.parse(issueListData?.files).map(v => {
            return (
              <a href={checkVipPicturePre(baseUrl, v.path)} target="_blank" title={v.name}>
                <img
                  style={{ height: '60px', width: '60px', margin: '5px' }}
                  src={checkVipPicturePre(baseUrl, v.path)}
                  alt={v.name}
                />
              </a>
            )
          })}
      </Form.Item>
    )
  }
  useEffect(() => {
    initFn()
  }, [])

  const initFn = async () => {
    const data = await Promise.all([ticketsIssueDetail(id), getFileUrlPrefix()]) //getIssueOne(issueId),

    setDetailsInfo({
      ...data[0],
      isRepeatCn: data[0]?.isRepeat ? '是' : '否',
      feedbackPhone_: data[0].feedbackPhone,
      phone_: data[0].customerInfo?.phone,
    })
    setBaseUrl(data[1])
    const _issueListDate = { ...data[0]?.customerInfo }
    Object.keys(_issueListDate).map((item: any) => {
      if (item == 'remoteSite' || item == 'visual') {
        _issueListDate[item] =
          _issueListDate[item] == 1 ? '是' : _issueListDate[item] == 0 ? '否' : ''
      }
      if (item == 'name') {
        _issueListDate['customerName'] = _issueListDate[item]
      }
    })
    setIssueListData({ ...data[0], ..._issueListDate, ...data[0]?.orderIssueList })
  }
  return (
    <SBack title={'详情'} level={2}>
      <div style={{ padding:' 0 20px 20px',backgroundColor: '#fff', borderBottomLeftRadius: '5px', borderBottomRightRadius: '5px'}}>
        <SGeneralForms
          ref={formRef}
          isDetail={true}
          configs={baseInfoConfig}
          detailsData={issueListData}
          initialValues={{ feedbackPhone: issueListData.feedbackPhone, phone: issueListData.phone }}
        />
        <div style={{ marginBottom: '10px' }}>
          <Tabs defaultActiveKey="1" onChange={() => {}}>
            <TabPane tab="工单列表" key="1">
              <OrderList issueId={id} formOnly={formOnly}></OrderList>
            </TabPane>
            <TabPane tab="处理结果" key="2">
              <OrderResult detailsInfo={detailsInfo} flag={'result'}></OrderResult>
            </TabPane>
            <TabPane tab="评价记录" key="3">
              <OrderResult detailsInfo={detailsInfo} flag={'comment'}></OrderResult>
            </TabPane>
            <TabPane tab="操作记录" key="5">
              <OperateLog id={id} issueId={issueId} sysItem="ISSUE"></OperateLog>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </SBack>
  )
}
